"use strict";

const IExecModule = require('./IExecModule');

const {
  createApporder,
  createDatasetorder,
  createRequestorder,
  createWorkerpoolorder,
  signApporder,
  signDatasetorder,
  signRequestorder,
  signWorkerpoolorder,
  hashApporder,
  hashDatasetorder,
  hashRequestorder,
  hashWorkerpoolorder,
  cancelApporder,
  cancelDatasetorder,
  cancelRequestorder,
  cancelWorkerpoolorder,
  matchOrders
} = require('../common/market/order');

const {
  publishApporder,
  publishDatasetorder,
  publishRequestorder,
  publishWorkerpoolorder,
  unpublishAllApporders,
  unpublishAllDatasetorders,
  unpublishAllRequestorders,
  unpublishAllWorkerpoolorders,
  unpublishApporder,
  unpublishDatasetorder,
  unpublishLastApporder,
  unpublishLastDatasetorder,
  unpublishLastRequestorder,
  unpublishLastWorkerpoolorder,
  unpublishRequestorder,
  unpublishWorkerpoolorder
} = require('../common/market/marketplace');

const {
  checkRequestRequirements
} = require('../common/execution/request-helper');

const {
  NULL_DATASETORDER
} = require('../common/utils/constant');

class IExecOrderModule extends IExecModule {
  constructor() {
    var _this;

    super(...arguments);
    _this = this;

    this.createApporder = async overwrite => createApporder(await this.config.resolveContractsClient(), overwrite);

    this.createDatasetorder = async overwrite => createDatasetorder(await this.config.resolveContractsClient(), overwrite);

    this.createWorkerpoolorder = async overwrite => createWorkerpoolorder(await this.config.resolveContractsClient(), overwrite);

    this.createRequestorder = async overwrite => createRequestorder({
      contracts: await this.config.resolveContractsClient(),
      resultProxyURL: await this.config.resolveResultProxyURL()
    }, overwrite);

    this.hashApporder = async apporder => hashApporder(await this.config.resolveContractsClient(), apporder);

    this.hashDatasetorder = async datasetorder => hashDatasetorder(await this.config.resolveContractsClient(), datasetorder);

    this.hashWorkerpoolorder = async workerpoolorder => hashWorkerpoolorder(await this.config.resolveContractsClient(), workerpoolorder);

    this.hashRequestorder = async requestorder => hashRequestorder(await this.config.resolveContractsClient(), requestorder);

    this.signApporder = async apporder => signApporder(await this.config.resolveContractsClient(), apporder);

    this.signDatasetorder = async datasetorder => signDatasetorder(await this.config.resolveContractsClient(), datasetorder);

    this.signWorkerpoolorder = async workerpoolorder => signWorkerpoolorder(await this.config.resolveContractsClient(), workerpoolorder);

    this.signRequestorder = async function (requestorder) {
      let {
        checkRequest = true
      } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return signRequestorder(await _this.config.resolveContractsClient(), checkRequest === true ? await checkRequestRequirements({
        contracts: await _this.config.resolveContractsClient(),
        smsURL: await _this.config.resolveSmsURL()
      }, requestorder).then(() => requestorder) : requestorder);
    };

    this.cancelApporder = async signedApporder => cancelApporder(await this.config.resolveContractsClient(), signedApporder);

    this.cancelDatasetorder = async signedDatasetorder => cancelDatasetorder(await this.config.resolveContractsClient(), signedDatasetorder);

    this.cancelWorkerpoolorder = async signedWorkerpoolorder => cancelWorkerpoolorder(await this.config.resolveContractsClient(), signedWorkerpoolorder);

    this.cancelRequestorder = async signedRequestorder => cancelRequestorder(await this.config.resolveContractsClient(), signedRequestorder);

    this.publishApporder = async signedApporder => publishApporder(await this.config.resolveContractsClient(), await this.config.resolveIexecGatewayURL(), signedApporder);

    this.publishDatasetorder = async signedDatasetorder => publishDatasetorder(await this.config.resolveContractsClient(), await this.config.resolveIexecGatewayURL(), signedDatasetorder);

    this.publishWorkerpoolorder = async signedWorkerpoolorder => publishWorkerpoolorder(await this.config.resolveContractsClient(), await this.config.resolveIexecGatewayURL(), signedWorkerpoolorder);

    this.publishRequestorder = async function (signedRequestorder) {
      let {
        checkRequest = true
      } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return publishRequestorder(await _this.config.resolveContractsClient(), await _this.config.resolveIexecGatewayURL(), checkRequest === true ? await checkRequestRequirements({
        contracts: await _this.config.resolveContractsClient(),
        smsURL: await _this.config.resolveSmsURL()
      }, signedRequestorder).then(() => signedRequestorder) : signedRequestorder);
    };

    this.unpublishApporder = async apporderHash => unpublishApporder(await this.config.resolveContractsClient(), await this.config.resolveIexecGatewayURL(), apporderHash);

    this.unpublishDatasetorder = async datasetorderHash => unpublishDatasetorder(await this.config.resolveContractsClient(), await this.config.resolveIexecGatewayURL(), datasetorderHash);

    this.unpublishWorkerpoolorder = async workerpoolorderHash => unpublishWorkerpoolorder(await this.config.resolveContractsClient(), await this.config.resolveIexecGatewayURL(), workerpoolorderHash);

    this.unpublishRequestorder = async requestorderHash => unpublishRequestorder(await this.config.resolveContractsClient(), await this.config.resolveIexecGatewayURL(), requestorderHash);

    this.unpublishLastApporder = async appAddress => unpublishLastApporder(await this.config.resolveContractsClient(), await this.config.resolveIexecGatewayURL(), appAddress);

    this.unpublishLastDatasetorder = async datasetAddress => unpublishLastDatasetorder(await this.config.resolveContractsClient(), await this.config.resolveIexecGatewayURL(), datasetAddress);

    this.unpublishLastWorkerpoolorder = async workerpoolAddress => unpublishLastWorkerpoolorder(await this.config.resolveContractsClient(), await this.config.resolveIexecGatewayURL(), workerpoolAddress);

    this.unpublishLastRequestorder = async () => unpublishLastRequestorder(await this.config.resolveContractsClient(), await this.config.resolveIexecGatewayURL());

    this.unpublishAllApporders = async appAddress => unpublishAllApporders(await this.config.resolveContractsClient(), await this.config.resolveIexecGatewayURL(), appAddress);

    this.unpublishAllDatasetorders = async datasetAddress => unpublishAllDatasetorders(await this.config.resolveContractsClient(), await this.config.resolveIexecGatewayURL(), datasetAddress);

    this.unpublishAllWorkerpoolorders = async workerpoolAddress => unpublishAllWorkerpoolorders(await this.config.resolveContractsClient(), await this.config.resolveIexecGatewayURL(), workerpoolAddress);

    this.unpublishAllRequestorders = async () => unpublishAllRequestorders(await this.config.resolveContractsClient(), await this.config.resolveIexecGatewayURL());

    this.matchOrders = async function (_ref) {
      let {
        apporder,
        datasetorder = NULL_DATASETORDER,
        workerpoolorder,
        requestorder
      } = _ref;
      let {
        checkRequest = true
      } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return matchOrders(await _this.config.resolveContractsClient(), apporder, datasetorder, workerpoolorder, checkRequest === true ? await checkRequestRequirements({
        contracts: await _this.config.resolveContractsClient(),
        smsURL: await _this.config.resolveSmsURL()
      }, requestorder).then(() => requestorder) : requestorder);
    };
  }

}

module.exports = IExecOrderModule;